import type { PreviewCardProps } from './types'

import { emotionTheme } from '@styles/theme'

import * as S from './styles'

export const PreviewCard = ({ label, value, percentageValue, rightIcon, textColor }: PreviewCardProps) => {
  return (
    <S.Container>
      <S.LeftBox>
        <S.Label>{label}</S.Label>

        <S.PercentageValue
          style={{
            color: textColor
          }}
        >
          {percentageValue}
        </S.PercentageValue>

        {!!value && (
          <S.Value
            style={{
              color: emotionTheme.colors.secondary
            }}
          >
            {value}
          </S.Value>
        )}
      </S.LeftBox>

      <S.IconBox
        style={{
          color: rightIcon?.color,
          background: rightIcon?.background
        }}
      >
        {rightIcon?.icon}
      </S.IconBox>
    </S.Container>
  )
}
